"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PersonalStep = void 0;
var _mui = require("@ori-ui/mui");
var _globalApiClientReact = require("@ori/global-api-client-react");
var _react = require("react");
var _Localization = require("../../Localization");
var _defaultTranslations_simplifiedRegistrationBrandPartner = require("../../constants/defaultTranslations_simplified-registration-BrandPartner");
var _contexts = require("../../contexts");
var _interfaces = require("../../interfaces");
var _models = require("../../models");
var _api = require("../../models/api");
var _utils = require("../../utils");
var _BasicSkeleton = require("../BasicSkeleton");
var _Forms = require("../Forms");
var _StepsStyledComponents = require("./StepsStyledComponents");
var _jsxRuntime = require("react/jsx-runtime");
const PersonalStep = () => {
  const {
    stepperData
  } = (0, _contexts.useStepperData)();
  const {
    activeStep,
    setActiveStep
  } = stepperData;
  const {
    notificationData
  } = (0, _contexts.useNotificationData)();
  const {
    setNotificationData
  } = notificationData;
  const [submitSuccess, setSubmitSuccess] = (0, _react.useState)(false);
  const {
    registrationId
  } = (0, _contexts.useConfiguration)();
  const {
    data: personalConfig
  } = (0, _api.usePersonalMetadata)();
  const {
    data: personalInitialData,
    isValidating
  } = (0, _api.usePersonalData)();
  const {
    errorData
  } = (0, _contexts.useFormError)();
  const {
    setErrorData,
    customErrors
  } = errorData;
  const api = (0, _globalApiClientReact.useApiClient)();
  const {
    virtualPageAnalyticsData
  } = (0, _contexts.useVirtualPageAnalyticsData)();
  const {
    setPreviousStep,
    previousStep
  } = virtualPageAnalyticsData;
  (0, _react.useEffect)(() => {
    (0, _utils.scrollTopFunctionHelper)();
  }, []);
  (0, _react.useEffect)(() => {
    (0, _utils.virtualPageEventDispatch)('PersonalInfoStep', previousStep, registrationId);
    setPreviousStep('PersonalInfoStep');
    // eslint-disable-next-line react-hooks/exhaustive-deps -- virtual page event should be fired exacly once, no need to reevaluate
  }, []);
  const onSubmit = async data => {
    const actualHours = new Date().getHours();
    const currentBirthDate = data.birthDate;
    // fix for bad time shift to previous day when fill text field in datepicker
    currentBirthDate?.setHours(actualHours, 0, 0);
    let currentAddress = null;
    if (data.address) {
      currentAddress = {
        address: {
          ...data.address,
          country: data.address.country,
          addressType: 'Delivery'
        }
      };
    }
    try {
      const updateResponse = await (0, _globalApiClientReact.updateCustomerRegistrationPersonalDetails)(api, registrationId, {
        ...data,
        ...currentAddress,
        birthDate: currentBirthDate
      });
      const result = new _models.FetchResult(updateResponse.status);
      if (result.isSuccess()) {
        setSubmitSuccess(true);
        setActiveStep(activeStep + 1);
        if (customErrors && customErrors.length > 0) {
          setErrorData([]);
        }
      }
    } catch (error) {
      const errorResponse = error;
      if (errorResponse.response?.status === _globalApiClientReact.HttpStatusCodes.status400BadRequest) {
        const {
          Errors
        } = errorResponse.response.data;
        const submitErrors = Errors?.map(er => ({
          fieldName: er.PropertyName,
          errorCode: er.Code
        }));
        if (submitErrors?.length && submitErrors.length > 0) {
          setErrorData(submitErrors);
        } else {
          setErrorData([]);
        }
      } else {
        setNotificationData({
          isOpen: true,
          message: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
            id: _models.TranslationKey.cannotUpdate,
            defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.cannotUpdate
          }),
          type: _interfaces.MessageType.error
        });
      }
    }
  };
  if (isValidating) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_BasicSkeleton.BasicSkeleton, {});
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_StepsStyledComponents.RootContainer, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_StepsStyledComponents.StyledTitle, {
      variant: "h4",
      color: "textPrimary",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
        id: _models.TranslationKey.FirstStep_Header,
        defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.FirstStep_Header
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
      variant: "subtitle1",
      color: "textPrimary",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
        id: _models.TranslationKey.FirstStep_Text,
        defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.FirstStep_Text
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Forms.PersonalDetailsForm, {
      initialData: personalInitialData,
      config: personalConfig,
      isSuccessSubmit: submitSuccess,
      onSubmitForm: onSubmit
    })]
  });
};
exports.PersonalStep = PersonalStep;